module.exports = __webpack_public_path__ + "img/floor2_4.64dff9c9.jpg";